import { IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import MaterialTable, { MTableToolbar } from 'material-table';
import React, { useEffect, useState } from 'react';
import { LoadingContainer } from './LoadingContainer';
import TooltipItem from './TooltipItem';
import AdvanceTable from '../advance-table/AdvanceTable';
import AdvanceTableWrapper from '../advance-table/AdvanceTableWrapper';
import AdvanceTablePagination from '../advance-table/AdvanceTablePagination';

const isFunctionalComponent = (Component) => {
  return (
    typeof Component === 'function' && // can be various things
    !(
      (
        Component.prototype && // native arrows don't have prototypes
        Component.prototype.isReactComponent
      ) // special property
    )
  );
};

export const CommonTableFrame = ({
  title,
  isLoading,
  data,
  columns,
  additionalToolbarComponent,
  additionalHeaderComponent,
  allowRefresh,
  handleRefresh,
  allowSearch,
  path,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSizeValue, setPageSizeValue] = useState(15);
  const PAGE_SIZE = 10;
  const pageLength = Math.ceil(data.length / PAGE_SIZE);
  const pages = Array(pageLength)
    .fill(null)
    .map((p, i) => i + 1);

  const ToolbarComponent = (props) => (
    <div className='table-custome-toolbar'>
      {/* <div className='table-toolbar-select '>
        <div className='header'>
          <h2
            className=''
            style={{ fontFamily: 'Brown', color: '#C98B76' }}
          >
            {title}
          </h2>
        </div>
      </div> */}
      <div className='common-table-toolbar-component relative'>
        {allowRefresh && (
          <>
            <TooltipItem
              item={{
                placement: 'bottom',
                text: 'Refresh',
              }}
              id={`tooltip_refresh`}
            />
            <IconButton
              aria-label='refresh table'
              component='span'
              onClick={handleRefresh}
              id={`tooltip_refresh`}
            >
              <Refresh />
            </IconButton>
          </>
        )}
        <MTableToolbar {...props} searchFieldStyle={{ fontFamily: 'Brown' }} />
      </div>
    </div>
  );

  const HeaderComponent = (props) => (
    <div className='header'>
      <h2 className=''>{title}</h2>
      {isFunctionalComponent(additionalHeaderComponent)
        ? additionalHeaderComponent(props)
        : null}
    </div>
  );

  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      pagination={data.length > 15}
      perPage={pageSizeValue}
      sortable={true}
    >
      <AdvanceTable
        table
        headerClassName='text-400 text-nowrap align-middle'
        rowClassName='align-middle white-space-nowrap'
        tableProps={{
          bordered: false,
          striped: false,
          loader: isLoading,
          className: 'fs--1 mb-0 overflow-x-auto',
        }}
      />
      {data.length > 15 ? (
        <div className='my-5'>
          <AdvanceTablePagination
            table
            rowsPerPageSelection
            setPageSize={(value) => setPageSizeValue(value)}
            pageSize={pageSizeValue}
          />
        </div>
      ) : null}
    </AdvanceTableWrapper>
  );
};
